import { hasPermission } from '@/utils'

function isOriginBackoffice() {
  return process.env.VUE_APP_ORIGIN_BACKOFFICE && process.env.VUE_APP_ORIGIN_BACKOFFICE === 'true'
}

export default {
  SET_NAV_MENU_ITEMS(state) {
    const menuItems = [
      {
        url: null,
        name: "Tenants",
        icon: "RssIcon",
        i18n: "Tenants",
        submenu: [
          {
            url: '/tenants',
            name: "TenantsCrud",
            slug: "tenant-list",
            i18n: "Gestão de Tenants"
          },
          isOriginBackoffice() ? {
            url: '/tenants/bulk-update-connections',
            name: "tenant-bulk-update-instances",
            slug: "tenant-list",
            i18n: "Atualizar Conexões em Massa"
          } : {},
          isOriginBackoffice() ? {
            url: '/tenants/nps-feature',
            name: "tenant-nps-feature",
            slug: "tenant-nps-feature",
            i18n: "NPS & Satisfação"
          } : {},
          isOriginBackoffice() ? {
            url: '/notification',
            name: "feature-notification",
            slug: "feature-notification",
            i18n: "Disparo de Notificação"
          } : {},
          isOriginBackoffice() ? {
            url: '/tenants/banners',
            name: "banners-list",
            slug: "banners-list",
            i18n: "Gestão de Avisos Chat"
          } : {}
        ]
      },
      {
        url: null,
        name: "Analytics",
        icon: "BarChartIcon",
        i18n: "Dados e Métricas",
        submenu: [
          {
            url: '/dashboard/analytics',
            name: "dashboard-analytics",
            slug: "dashboard-analytics",
            i18n: "Analytics"
          },
          {
            url: '/dashboard/control-panel',
            name: "dashboard-control-panel",
            slug: "dashboard-control-panel",
            i18n: "Painel de Controle"
          },
          {
            url: '/dashboard/maria-panel',
            name: "dashboard-maria-panel",
            slug: "dashboard-maria-panel",
            i18n: "Painel da MarIa"
          },
          {
            url: '/dashboard/produtivity-report',
            name: "dashboard-produtivity-report",
            slug: "dashboard-produtivity-report",
            i18n: "Produtividade"
          },
          isOriginBackoffice() ? {
            url: '/dashboard/orders-sales-report',
            name: "orders-sales-report",
            slug: "orders-sales-report",
            i18n: "Gestão de Pedidos"
          } : {},
          {
            url: '/dashboard/report',
            name: "dashboard-report",
            slug: "dashboard-report",
            i18n: "Métricas de Segurança"
          },
          {
            url: '/dashboard/maria-analitica-panel',
            name: "dashboard-maria-analitica-panel",
            slug: "dashboard-maria-analitica-panel",
            i18n: "MarIA Analítica"
          },
          isOriginBackoffice() ? {
            url: '/dashboard/nps-feature-analytics',
            name: "dashboard-nps-feature-analytics",
            slug: "tenant-nps-feature",
            i18n: "NPS & Satisfação"
          } : {},
          {
            url: '/dashboard/report-smart',
            name: "dashboard-report-smart",
            slug: "dashboard-report-smart",
            i18n: "Métricas Inteligentes"
          },
          {
            url: '/dashboard/usage-report',
            name: "dashboard-usage-report",
            slug: "dashboard-usage-report",
            i18n: "Frequência de Uso"
          },
          {
            url: '/dashboard/total-attendances-report',
            name: "dashboard-total-attendances-report",
            slug: "dashboard-total-attendances-report",
            i18n: "Relatórios & Exportações"
          }
        ]
      },
      {
        url: null,
        name: "Access",
        icon: "UnlockIcon",
        i18n: "Access",
        submenu: [
          {
            url: '/roles/list',
            name: "roles-list",
            slug: "roles-list",
            i18n: "Roles",
          },
        ]
      },
      {
        url: null,
        name: "Users",
        icon: "UsersIcon",
        i18n: "Usuários",
        submenu: [
          {
            url: '/users',
            name: "User",
            slug: "users-list",
            i18n: "Gestão de Usuários"
          }
        ]
      },
      isOriginBackoffice() ? {
        url: null,
        name: "Approvals",
        icon: "CheckSquareIcon",
        i18n: "Aprovações",
        submenu: [
          {
            url: '/approvals/pending',
            name: "approval-list",
            slug: "approval-list",
            i18n: "Agendamentos"
          },
          {
            url: '/approvals/my-requests',
            name: "requests",
            slug: "requests",
            i18n: "Minhas Solicitações"
          },
        ]
      } : {},
      isOriginBackoffice() ? {
        url: null,
        name: "ConversationBot",
        icon: "SmileIcon",
        i18n: "Robôs",
        submenu: [
          {
            url: '/chat-flows/passive/list',
            name: "chat-flows-passive-list",
            slug: "chat-flows-passive-list",
            i18n: "Bot de Triagem"
          },
          {
            url: '/chat-flows/active/list',
            name: "chat-flows-active-list",
            slug: "chat-flows-active-list",
            i18n: "Bot de Campanhas"
          }
        ]
      } : {},
      isOriginBackoffice() ? {
        url: null,
        name: "Campaigns",
        icon: "SendIcon",
        i18n: "Campaigns",
        submenu: [
          {
            url: '/whatsapp/campaigns',
            name: 'whatsapp-campaigns',
            slug: 'whatsapp-campaigns',
            i18n: 'WhatsApp'
          }
        ]
      } : {},
      isOriginBackoffice() ? {
        url: null,
        name: "CRM",
        icon: "BookIcon",
        i18n: "CRM",
        submenu: [
          {
            url: '/crm/categories',
            name: 'customer-categories-mass',
            slug: 'customer-categories-mass',
            i18n: 'Categorias de Contato'
          }
        ]
      } : {},
    ];

    const alwaysAllowed = [
      'rules',
      'help-support',
    ]

    state.navMenuItems = menuItems.filter(item => {
      if (item.url !== null) {
        return hasPermission(item.slug) ? item : false
      } else {
        item.submenu = item.submenu.filter(sub => {
          if (sub.slug === null || alwaysAllowed.indexOf(sub.slug) >= 0) {
            return item
          }

          return hasPermission(sub.slug) ? item : false
        })

        if (item.submenu.length === 0) {
          return false
        }
      }

      return item
    })
  },
  CLEAR_NAV_MENU_ITEMS(state) {
    state.navMenuItems = [];
  },
}
